export const messages = {
  en: {
    propertyRightDetail: {
      title: 'Property Registration Details',
      table: {
        id: 'ID',
        materialType: 'Material Type',
        isPayment: 'Payment Status',
        image: 'Images',
        createTime: 'Create Time',
        operation: 'Operations'
      },
      edit: {
        title: 'Edit Property Registration',
        materialType: 'Material Type',
        materialTypePlaceholder: 'Required, please enter material type',
        materialTypeRequired: 'Material type is required',
        idCardPhoto: 'ID Card Photos',
        idCardPhotoTip: 'Please upload front and back photos of ID card',
        houseContract: 'House Purchase Contract',
        houseContractTip: 'Please upload up to 10 house purchase contract photos',
        repairFund: 'Repair Fund Payment',
        repairFundPlaceholder: 'Please select repair fund payment status',
        repairFundPhoto: 'Repair Fund Proof',
        deedTax: 'Deed Tax Payment',
        deedTaxPlaceholder: 'Please select deed tax payment status',
        deedTaxPhoto: 'Deed Tax Proof'
      },
      fetchError: 'Failed to fetch property registration details'
    }
  },
  zh: {
    propertyRightDetail: {
      title: '产权登记详情',
      table: {
        id: 'ID',
        materialType: '材料类型',
        isPayment: '是否缴费',
        image: '图片',
        createTime: '创建时间',
        operation: '操作'
      },
      edit: {
        title: '修改产权登记',
        materialType: '材料类型',
        materialTypePlaceholder: '必填，请填写材料类型',
        materialTypeRequired: '材料类型不能为空',
        idCardPhoto: '身份证照片',
        idCardPhotoTip: '请上传正反两张身份证照片',
        houseContract: '购房合同',
        houseContractTip: '请上传不超过十张购房合同照片',
        repairFund: '维修基金缴纳',
        repairFundPlaceholder: '请选择维修基金缴纳状态',
        repairFundPhoto: '维修基金证明',
        deedTax: '契税缴纳',
        deedTaxPlaceholder: '请选择契税缴纳状态',
        deedTaxPhoto: '契税证明'
      },
      fetchError: '获取产权登记详情失败'
    }
  }
}